module.exports = __webpack_public_path__ + "static/img/reward_card.cb01e974.png";